import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, CalendarDays, Star } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { formatBlogDate, getBlogPostPath, resolveBlogExcerpt } from '@/utils/blog';

const BlogPostCard = ({ post }) => {
  const articlePath = getBlogPostPath(post?.slug);
  const excerpt = resolveBlogExcerpt(post);

  return (
    <Card className="group overflow-hidden rounded-3xl border border-slate-200/80 bg-white shadow-[0_20px_70px_-45px_rgba(15,23,42,0.4)] transition-transform duration-300 hover:-translate-y-1">
      <div className="relative">
        {post?.cover_image_url ? (
          <img
            src={post.cover_image_url}
            alt={post?.title || 'Article de blog Coli Noki'}
            loading="lazy"
            className="h-56 w-full object-cover transition-transform duration-500 group-hover:scale-[1.02]"
          />
        ) : (
          <div className="flex h-56 w-full items-end bg-gradient-to-br from-red-500 via-red-600 to-cyan-500 p-6">
            <p className="max-w-xs text-sm font-medium uppercase tracking-[0.24em] text-white/80">
              Coli Noki Blog
            </p>
          </div>
        )}
        <div className="absolute left-5 right-5 top-5 flex flex-wrap items-center gap-2">
          {post?.category ? (
            <Badge className="bg-cyan-600 text-white shadow-sm">
              {post.category}
            </Badge>
          ) : null}
          <Badge className="bg-white/90 text-slate-700 shadow-sm">
            <CalendarDays className="mr-1 h-3.5 w-3.5" />
            {formatBlogDate(post?.created_at)}
          </Badge>
          {post?.is_featured && (
            <Badge className="bg-red-600 text-white shadow-sm">
              <Star className="mr-1 h-3.5 w-3.5" />
              A la une
            </Badge>
          )}
        </div>
      </div>

      <CardContent className="space-y-5 p-6">
        <div className="space-y-3">
          <h3 className="line-clamp-2 text-2xl font-semibold tracking-tight text-slate-950">
            {post?.title || 'Article Coli Noki'}
          </h3>
          <p className="line-clamp-3 text-sm leading-7 text-slate-600">{excerpt}</p>
        </div>

        <div className="flex items-center justify-between gap-3 border-t border-slate-100 pt-4">
          <p className="text-sm text-slate-500">{post?.author || 'Equipe Coli Noki'}</p>
          <Button asChild variant="outline" className="rounded-full border-red-100 text-red-600 hover:bg-red-50 hover:text-red-700">
            <Link to={articlePath}>
              Lire l'article
              <ArrowRight className="ml-2 h-4 w-4" />
            </Link>
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};

export default BlogPostCard;
